export const YOUTUBE_TUTORIAL_VIDEO_ID = 'iuxQdBCq_WU';
export const ZITOTRON_YOUTUBE_CHANNEL_ID = 'UCXTGUlYvVcd16B7hipbegRQ';
export const ZITOTRON_YOUTUBE_UPLOADS_PLAYLIST_ID = `UU${ZITOTRON_YOUTUBE_CHANNEL_ID.slice(2)}`;
export const YOUTUBE_TUTORIAL_URL = `https://www.youtube.com/watch?v=${YOUTUBE_TUTORIAL_VIDEO_ID}`;
export const YOUTUBE_TUTORIAL_THUMBNAIL_URL = '/tutorials/agentomatic-install-use-thumbnail-960.webp';
export const YOUTUBE_TUTORIAL_THUMBNAIL_SRCSET =
  '/tutorials/agentomatic-install-use-thumbnail-640.webp 640w, /tutorials/agentomatic-install-use-thumbnail-960.webp 960w, /tutorials/agentomatic-install-use-thumbnail-1280.webp 1280w';
export const YOUTUBE_TUTORIAL_THUMBNAIL_SIZES = '(max-width: 720px) calc(100vw - 56px), 1010px';
export const YOUTUBE_CHANNEL_VIDEOS_URL = 'https://www.youtube.com/@ZitotronTechLLC/videos';
export const X_PROFILE_URL = 'https://x.com/ZitotronTechLLC';
export const YOUTUBE_TUTORIAL_EMBED_URL =
  `https://www.youtube-nocookie.com/embed/${YOUTUBE_TUTORIAL_VIDEO_ID}?playsinline=1&rel=0&modestbranding=1&mute=1&vq=hd720`;
export const YOUTUBE_TUTORIAL_PLAY_EMBED_URL =
  `https://www.youtube-nocookie.com/embed/${YOUTUBE_TUTORIAL_VIDEO_ID}?autoplay=1&playsinline=1&rel=0&modestbranding=1&mute=1&vq=hd720&start=525`;
export const YOUTUBE_TUTORIAL_PAGE_PLAY_EMBED_URL =
  `https://www.youtube-nocookie.com/embed/${YOUTUBE_TUTORIAL_VIDEO_ID}?autoplay=1&playsinline=1&rel=0&modestbranding=1&mute=1&vq=hd720&start=841`;

export type YoutubeTutorialVideo = {
  id: string;
  title: string;
  url: string;
  publishedAt?: string;
  updatedAt?: string;
  thumbnailUrl?: string;
  description?: string;
};

export const ZITOTRON_YOUTUBE_FALLBACK_VIDEOS: YoutubeTutorialVideo[] = [
  {
    id: 'BaOMsUeb9is',
    title: 'Antigravity CLI & Gemini 3.5 Tutorial',
    url: 'https://www.youtube.com/watch?v=BaOMsUeb9is',
    publishedAt: '2026-05-22T18:58:14+00:00',
  },
  {
    id: 'Df-74ljitaA',
    title: 'Grok Build Agentic Engineering - How To Start',
    url: 'https://www.youtube.com/watch?v=Df-74ljitaA',
    publishedAt: '2026-05-18T20:42:28+00:00',
  },
  {
    id: 'iuxQdBCq_WU',
    title: 'How To Start Agentic Engineering on Linux - Ubuntu',
    url: YOUTUBE_TUTORIAL_URL,
    publishedAt: '2026-05-14T08:01:39+00:00',
  },
];

export function youtubeTutorialEmbedUrl(videoId: string): string {
  return `https://www.youtube-nocookie.com/embed/${videoId}?playsinline=1&rel=0&modestbranding=1&vq=hd720`;
}

export function youtubeUploadsPlaylistEmbedUrl(): string {
  return `https://www.youtube-nocookie.com/embed/videoseries?list=${ZITOTRON_YOUTUBE_UPLOADS_PLAYLIST_ID}&playsinline=1&rel=0&modestbranding=1&vq=hd720`;
}
